<template>
    <div class="navRoute contentWidth_Parent">
        <div class="contentWidth_Child pt-2 pb-2">
            <div>

                <router-link class="font-grey" v-bind:t_label="'EMPBE_Breadcrumbs_SupplierSubmissionCentre'" :to="{ path: '/' }">{{ $t("lbl_EMPBE_SupplierSubmissionCentre") }}
                    </router-link>
                <i class="icon-angle-right breadcrumbsArrow"></i>
                <span class="breadcrumb-item m-l-5" v-if="title">  {{ title }}</span>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    components: {},
    props: {
        title: {
            default: "home",
        },
        main: {
            default: "",
        },
    },
};
</script>
<style>
.navRoute {
    z-index: 9;
    position: fixed;
    top: 131px;
    font-weight: 400;
    line-height: 1.5;
    color: #2e2e2e !important;
    font-family: "Microsoft Yahei", Arial, Helvetica, Arial, sans-serif !important;
    font-size: 14px !important;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    list-style-type: none;
    text-align: -webkit-center;
    background: #dfdede no-repeat;
    width: 100%;
    left: 0px;
    display: none;
}

.breadcrumbsArrow {
    font-size: 11px;
    margin-left: 5px;
    color: #a67f8f;
}
</style>